<template>
  <div class="d-inline-flex align-end smoker-section">
    <div class="d-flex smoker-icon-parent" @click="selectedSmoker(true)">
      <div class="smoker-icon-container">
        <v-img
          :src="require(`@/assets/${this.smokerImage()}`)"
          aspect-ratio="1"
          class="smoker-icon"
        />
      </div>
      Yes
    </div>
    <div class="d-flex smoker-icon-parent" @click="selectedSmoker(false)">
      <div class="smoker-icon-container">
        <v-img
          :src="require(`@/assets/${this.nonSmokerImage()}`)"
          aspect-ratio="1"
          class="smoker-icon"
        />
      </div>
      No
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SmokingInput',
    components: {},
    props: {
      value: Boolean,
    },
    data() {
      return {
        smoker: this.value,
      };
    },
    computed: {},
    methods: {
      selectedSmoker(value) {
        this.smoker = value;
        this.$emit('input', value);
      },
      smokerImage() {
        return this.smoker
          ? this.whitelabel.images.getFreeInsuranceQuotePageSmokerSelected
          : this.whitelabel.images.getFreeInsuranceQuotePageSmoker;
      },
      nonSmokerImage() {
        return this.smoker === false
          ? this.whitelabel.images.getFreeInsuranceQuotePageNonSmokerSelected
          : this.whitelabel.images.getFreeInsuranceQuotePageNonSmoker;
      },
    },
  };
</script>

<style lang="scss">
  .smoker-icon-container {
    width: 24px;
  }

  .smoker-icon-parent {
    cursor: pointer;
  }

  .smoker-icon-parent:first-of-type {
    margin-right: 12px;
  }

  .smoker-icon-container:first-of-type {
    margin-right: 8px;
  }

  .smoker-section {
    padding-top: 18px;
  }
</style>
